interface HTMLElementWithFocusTrap extends HTMLElement {
    sfFocusTrap: (event: KeyboardEvent) => void
}

const vFocusTrap = {
    mounted(el: HTMLElementWithFocusTrap) {
        el.sfFocusTrap = (event: KeyboardEvent) => {
            if (event.key !== "Tab" || document.body.classList.contains("swal2-shown")) return;
            event.preventDefault();

            const focusableSelectors = [
                "button",
                "[href]",
                "input",
                "select",
                "textarea",
                "[tabindex]"
            ];
            let focusableElements = Array.from(el.querySelectorAll(focusableSelectors.join(", "))) as HTMLElement[];


            focusableElements = focusableElements.filter(element => {
                const isDisabled = element.hasAttribute("disabled");
                const tabIndex = element.getAttribute("tabindex");
                const isVisible = element.offsetParent !== null;
                const isTabIndexNegative = tabIndex !== null && tabIndex === "-1";
                return !isDisabled && !isTabIndexNegative && isVisible;
            });

            // Sort elements by tabindex
            focusableElements.sort((a, b) => {
                const tabIndexA = a.getAttribute("tabindex") ? parseInt(a.getAttribute("tabindex")!, 10) : 0;
                const tabIndexB = b.getAttribute("tabindex") ? parseInt(b.getAttribute("tabindex")!, 10) : 0;
                return tabIndexA - tabIndexB;
            });

            if (!focusableElements.length) return;

            let currentIndex = focusableElements.indexOf(document.activeElement as HTMLElement);
            if (event.shiftKey) { // Shift + Tab
                currentIndex--;
                if (currentIndex < 0) currentIndex = focusableElements.length - 1;
            } else { // Tab
                currentIndex++;
                if (currentIndex > focusableElements.length - 1) currentIndex = 0;
            }
            focusableElements[currentIndex].focus();
        };
        document.addEventListener("keydown", el.sfFocusTrap);
    },
    unmounted(el: HTMLElementWithFocusTrap) {
        document.removeEventListener("keydown", el.sfFocusTrap);
    }
};

export default vFocusTrap;
